import { Component, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { finalize, switchMap, take } from 'rxjs/operators';
import { ConfigService } from 'src/app/services/config.service';
import { GoogleAuthService } from 'src/app/services/google-auth.service';

@Component({
  selector: 'app-google-account-settings',
  templateUrl: './google-account-settings.component.html',
  styleUrls: ['./google-account-settings.component.scss']
})
export class GoogleAccountSettingsComponent implements OnInit {

  profileInfo: any = null;

  authHistory: any[] = [];

  pollingCountDown: number = 0;

  secondhandDriveID: string = '';

  isPolling: boolean = false;
  isApiCalling: boolean = false;
  isHistoryLoading: boolean = false;
  showDeletionConfirmationAlert: boolean = false;

  private pollingSubscription: Subscription | null = null;
  private countdownSubscription?: Subscription | null = null;

  constructor(
    private authService: GoogleAuthService,
    private config: ConfigService
  ) { }

  ngOnInit(): void {
    this.getGoogleProfile();
    this.getGoogleAuthHistory();
    this.checkSignInStatus();
  }

  private getGoogleProfile() {
    this.isApiCalling = true;
    this.authService.getGoogleProfile().subscribe(
      (res: any) => {
        if (res && res.Result === "Success" && res.ResponseData) {
          this.profileInfo = res.ResponseData;
        }
        this.isApiCalling = false;
      },
      (error) => {
        console.error('API Error:', error);
        this.isApiCalling = false;
      }
    );
  }

  public deleteAccount() {
    this.showDeletionConfirmationAlert = true;
  }

  public handleCancel() {
    this.showDeletionConfirmationAlert = false;
  }

  public handleConfirm() {
    this.isApiCalling = true;
    this.authService.removeGoogleAccount()
      .pipe(finalize(() => {
        this.isApiCalling = false;
        this.showDeletionConfirmationAlert = false;
      })).subscribe((res: any) => {
        if (res && res.Result === "Success" && res.ResponseData === "Success") {
          this.profileInfo = null;
          this.getGoogleAuthHistory();
        }
      },
        (error) => {
          console.error('Remove Google account failed:', error);
        }
      );
  }

  public redirectToAuthDomain(): void {
    const fullUrl = window.location.href;
    const [baseUrl, hashPart] = fullUrl.split('/#/');
    const [_, queryParams] = hashPart.split('?');
    const redirectedUrl =
      `https://mobileauth.tobeonline.in/#/admin/driveSignIn` +
      // `http://localhost:4200/#/admin/driveSignIn` + //local testing
      (queryParams ? `?${queryParams}` : '');
    window.open(redirectedUrl, '_blank');
    this.startSignInPolling();
  }

  private checkSignInStatus(): void {
    this.authService.getGoogleProfile().subscribe((res: any) => {
      if (res?.Result === 'Success' && res?.ResponseData) {
        this.profileInfo = res?.ResponseData;
      } else {
        this.profileInfo = null;
      }
    });
  }

  private getGoogleAuthHistory() {
    this.isHistoryLoading = true;
    this.authService.getGoogleAuthHistory().subscribe(
      (res: any) => {
        if (res && res.Result === "Success" && res.ResponseData) {
          this.authHistory = res.ResponseData;
        }
        this.isHistoryLoading = false;
      },
      (error: any) => {
        console.error('API Error:', error);
        this.isHistoryLoading = false;
      }
    );
  }

  private startSignInPolling(): void {
    this.isPolling = true;
    this.pollingCountDown = 100;
    this.countdownSubscription = interval(1000).subscribe(() => {
      this.pollingCountDown--;
      if (this.pollingCountDown <= 0) {
        this.stopSignInPolling();
        this.isPolling = false;
        this.pollingCountDown = 0;
      }
    });
    this.pollingSubscription = interval(10000)
      .pipe(
        take(10),
        switchMap(() => this.authService.getGoogleProfile())
      )
      .subscribe({
        next: (res: any) => {
          const profile = res?.ResponseData;
          if (res?.Result === 'Success' && profile) {
            this.profileInfo = profile;
            this.stopSignInPolling();
          }
        },
        error: (err) => {
          console.error('Polling error:', err);
          this.isPolling = false;
        },
        complete: () => {
          this.isPolling = false;
          this.getGoogleAuthHistory();
        }
      });
  }

  private stopSignInPolling(): void {
    this.pollingSubscription?.unsubscribe();
    this.pollingSubscription = undefined;
    this.countdownSubscription?.unsubscribe();
    this.countdownSubscription = undefined;
    this.isPolling = false;
  }

}
